/* VARS */
var jsondata = {}, dataField, mainObj, subObj, activeScene = 1, startTimeline = true;
window.MENU_LABEL = {};
window.data1 = {};
window.elements1 = {};
var verze = "NEWS";
